import apiClient from './api';
import API_ENDPOINTS from './endpoints';
export const authService = {
    register(payload) {
        return apiClient.post(API_ENDPOINTS.AUTH.REGISTER, payload);
    },
    loginWithGoogle(payload) {
        return apiClient.post(API_ENDPOINTS.AUTH.GOOGLE, payload);
    }
};
export default authService;
